//フローティングバナー
const intersectionContainer = document.querySelector(".js-footer-inner");
const intersectionTarget = document.querySelector(".js-float-button");
const infiniteScrollObserver = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      console.log(entry.intersectionRatio * 100);
      if (!entry.isIntersecting) {
        intersectionTarget.classList.remove("is-hidden");
      } else {
        intersectionTarget.classList.add("is-hidden");
      }
    });
  },
  {
    threshold: buildThresholdList(),
  }
);
infiniteScrollObserver.observe(intersectionContainer);
function buildThresholdList() {
  let numSteps = 90;
  let thresholds = [];

  for (let i = 1; i <= numSteps; i++) {
    let ratio = i / numSteps;
    thresholds.push(ratio);
  }
  return thresholds;
}